import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import {
  employeeAvatarImg,
  getCurrentEmployeeImageUrl,
  localStorageGet,
} from '../helper';

import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
} from './SettingsUtils';

const useStyles = makeStyles((theme) => ({
  settingsThemeContainer: {
    width: '50%',
    margin: '20px auto 0 auto',
    [theme.breakpoints.down('sm')]: {
      width: 'calc(100% - 25px) !important',
      margin: '10px auto 0px auto !important',
    },
  },
  adminAvatar: {
    '& img': {
      '-webkit-box-shadow': '2px 2px 10px 0px rgba(0,0,0,0.54)',
      '-moz-box-shadow': '2px 2px 10px 0px rgba(0,0,0,0.54)',
      'box-shadow': '2px 2px 10px 0px rgba(0,0,0,0.54)',
      [theme.breakpoints.down('sm')]: {
        width: '40px !important',
        height: '40px !important;',
      },
    },
  },
  w100: {
    width: '100%',
    display: 'flex',
  },
  rightSide: { margin: 'auto 10px', 'font-size': 'large' },
  name: { 'font-weight': 'bold', margin: '0 0 10px 0' },
  emailAddress: { color: 'gray', margin: '0px', fontSize: '12px' },
}));

const AdminProfile = () => {
  const [expanded, setExpanded] = useState(true);
  const classes = useStyles();
  const employeeAvatar = () =>
    employeeAvatarImg(getCurrentEmployeeImageUrl(), 70, 3);

  const user = localStorageGet('user');

  if (!user) {
    return null;
  }

  return (
    <div className={classes.settingsThemeContainer}>
      <ExpansionPanel
        square
        expanded={expanded}
        onChange={() => setExpanded(!expanded)}
      >
        <ExpansionPanelSummary
          aria-controls="panel1d-content"
          expandIcon={<ExpandMoreIcon />}
          id="panel1d-header"
        >
          <Typography>My Profile</Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          <div className={classes.w100}>
            <div className={classes.adminAvatar}>{employeeAvatar()}</div>
            <div className={classes.rightSide}>
              <p className={classes.name}>
                {user.first_name} {user.last_name}
              </p>
              <p className={classes.emailAddress}>{user.username}</p>
            </div>
          </div>
        </ExpansionPanelDetails>
        <Divider />
      </ExpansionPanel>
    </div>
  );
};

export default AdminProfile;
